const URL_KEY = /(url|referrer)$/i;

function stripQuery(value) {
  return typeof value === 'string' ? value.split(/[?#]/)[0] : value;
}

function stripMap(map) {
  if (!map || typeof map !== 'object') {
    return map;
  }

  const stripped = { ...map };

  Object.keys(stripped).forEach(key => {
    if (URL_KEY.test(key)) {
      stripped[key] = stripQuery(stripped[key]);
    }
  });

  return stripped;
}

function stripSnapshotItem(item) {
  if (!item || typeof item !== 'object' || !item.data || typeof item.data !== 'object') {
    return item;
  }

  const { href, payload } = item.data;
  const strippedPayload =
    payload && typeof payload === 'object' && typeof payload.href === 'string'
      ? { ...payload, href: stripQuery(payload.href) }
      : payload;

  if (typeof href !== 'string' && strippedPayload === payload) {
    return item;
  }

  return {
    ...item,
    data: {
      ...item.data,
      ...(typeof href === 'string' ? { href: stripQuery(href) } : {}),
      ...(strippedPayload === payload ? {} : { payload: strippedPayload }),
    },
  };
}

/**
 * Search boxes put buyer emails in the dashboard URL, and posthog-js skips
 * `sanitize_properties` for `$snapshot` events, so replay keeps the raw URL.
 * The SDK copies that URL into person properties and session entry properties
 * as well, so every url/referrer key is stripped wherever it appears.
 */
export default function stripUrlsFromEvent(event) {
  if (!event || typeof event !== 'object') {
    return event;
  }

  const stripped = { ...event };

  if (stripped.$set) {
    stripped.$set = stripMap(stripped.$set);
  }

  if (stripped.$set_once) {
    stripped.$set_once = stripMap(stripped.$set_once);
  }

  if (stripped.properties) {
    const properties = stripMap(stripped.properties);

    if (properties.$set) {
      properties.$set = stripMap(properties.$set);
    }

    if (properties.$set_once) {
      properties.$set_once = stripMap(properties.$set_once);
    }

    if (Array.isArray(properties.$snapshot_data)) {
      properties.$snapshot_data = properties.$snapshot_data.map(stripSnapshotItem);
    }

    stripped.properties = properties;
  }

  return stripped;
}
